import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private apiService: ApiService) {}

  reset(email: string, method: string = 'link'): Observable<any> {
    return this.apiService.post<any>('/password/reset', {email, method}, false);
  }

  resetByCode(code: string, password: string): Observable<any> {
    return this.apiService.put<any>('/password/reset/by-code', {code, password}, false);
  }

  resetPut(id: string, password: string): Observable<any> {
    return this.apiService.put<any>('/password/reset/' + id, {password}, false);
  }

  change(oldPassword: string, newPassword: string): Observable<any> {
    return this.apiService.put<any>('/password/change', {oldPassword, newPassword}, true);
  }

}
